// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_extraMargin__T\\+aNk{
    margin:0 1%;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/MessageDateSeeen/styles.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf","sourcesContent":[".extraMargin{\n    margin:0 1%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"extraMargin": `styles_extraMargin__T+aNk`
};
export default ___CSS_LOADER_EXPORT___;
